import {
	LOCALE_GET,
	LOCALE_SET, LOCALIZATION_MESSAGES_DELETE, LOCALIZATION_MESSAGES_SET, TRANSLATED_DIFFERENCE,
	UPLOAD_USER_LOCALISATION
} from 'actions/localization'
import store from '../../store'
import http from 'utils/http'
import axios from 'axios'
import i18n from '../../locales'
import Vue from 'vue'
import { checkConfigUpdate } from 'modules/configurations'
import { AUTH_LOGOUT } from 'actions/authentication'

const state = {
	locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : process.env.VUE_APP_DEFAULT_LANG,
	loadedCommonLocale: false,
	loadedCompanyLocale: '',
	translationDifference: {},
	COMMON_LOCALIZATION_MESSAGES: JSON.parse(localStorage.getItem('COMMON_LOCALIZATION_MESSAGES')) || {
		data: [],
		etag: ''
	},
	COMPANY_LOCALIZATION_MESSAGES: JSON.parse(localStorage.getItem('COMPANY_LOCALIZATION_MESSAGES')) || {
		data: [],
		etag: ''
	}
}

const getters = {
	getLocale: state => state.locale,
	getTranslationDifference: state => state.translationDifference,
	getStatusLoadedCommonLocale: state => state.loadedCommonLocale
}

const actions = {
	[LOCALE_GET]: ({ commit, dispatch }) => {
		return getI18n(store.getters.getLocale, 'common')
			.then((res) => {
				i18n.locale = store.getters.getLocale
				i18n.setLocaleMessage(store.getters.getLocale, res.data)
				window.i18n = i18n
				document.querySelector('html').setAttribute('lang', store.getters.getLocale)
				commit(LOCALE_GET)
				commit(LOCALIZATION_MESSAGES_SET, { COMMON_LOCALIZATION_MESSAGES: res })
			})
			.catch(error => {
				console.log(error)
				Vue.rollbar.error('LOCALE_GET', error)
			})
	},
	[LOCALE_SET]: ({ commit, dispatch }, locale) => {
		i18n.locale = locale
		if (state.locale !== locale) {
			commit(LOCALIZATION_MESSAGES_DELETE)
			getI18n(locale, 'common')
				.then((response) => {
					i18n.setLocaleMessage(locale, response.data)
					commit(LOCALE_SET, locale)
					localStorage.setItem('locale', i18n.locale)
					if (store.getters.isAuthenticated) {
						dispatch(UPLOAD_USER_LOCALISATION, i18n.locale)
					}
				})
				.then(() => {
					if (window.table) {
						window.table.initTable()
					}
				})
				.catch(error => {
					console.log(error)
					Vue.rollbar.error('LOCALE_SET', error)
				})
		}
	},
	[UPLOAD_USER_LOCALISATION]: ({ commit, dispatch }) => {
		let locale = state.locale
		getI18n(locale, 'company')
			.then((resp) => {
				i18n.mergeLocaleMessage(locale, resp.data)
				commit(UPLOAD_USER_LOCALISATION, locale)
				commit(LOCALIZATION_MESSAGES_SET, { COMPANY_LOCALIZATION_MESSAGES: resp})
			})
			.catch(error => {
				console.log(error)
				Vue.rollbar.error('UPLOAD_USER_LOCALISATION', error)
			})
	},
	[TRANSLATED_DIFFERENCE]: ({ commit }) => {
		return http.get('/translation/difference')
			.then((diff) => {
				commit(TRANSLATED_DIFFERENCE, diff)
			})
			.catch(err => {
				console.log(err)
				Vue.rollbar.error('TRANSLATED_DIFFERENCE', err)
			})
	}
}

const mutations = {
	[LOCALE_GET]: (state) => {
		state.loadedCommonLocale = true
	},
	[LOCALE_SET]: (state, locale) => {
		state.locale = locale
		window.locale = locale
		state.loadedCommonLocale = true
	},
	[LOCALIZATION_MESSAGES_SET]: (state, messages) => {
		if (messages.COMMON_LOCALIZATION_MESSAGES) {
			state.COMMON_LOCALIZATION_MESSAGES = {
				data: messages.COMMON_LOCALIZATION_MESSAGES.data,
				etag: messages.COMMON_LOCALIZATION_MESSAGES.headers ? messages.COMMON_LOCALIZATION_MESSAGES.headers.etag.split('"')[1] : messages.COMMON_LOCALIZATION_MESSAGES.etag
			}
			localStorage.setItem('COMMON_LOCALIZATION_MESSAGES', JSON.stringify(state.COMMON_LOCALIZATION_MESSAGES))
		}
		if (messages.COMPANY_LOCALIZATION_MESSAGES) {
			state.COMPANY_LOCALIZATION_MESSAGES = {
				data: messages.COMPANY_LOCALIZATION_MESSAGES.data,
				etag: messages.COMPANY_LOCALIZATION_MESSAGES.headers ? messages.COMPANY_LOCALIZATION_MESSAGES.headers.etag.split('"')[1] : messages.COMPANY_LOCALIZATION_MESSAGES.etag
			}
			localStorage.setItem('COMPANY_LOCALIZATION_MESSAGES', JSON.stringify(state.COMPANY_LOCALIZATION_MESSAGES))
		}
	},
	[LOCALIZATION_MESSAGES_DELETE]: (state) => {
		state.COMMON_LOCALIZATION_MESSAGES = {
			data: {},
			etag: ''
		}
		state.COMPANY_LOCALIZATION_MESSAGES = {
			data: {},
			etag: ''
		}
		localStorage.removeItem('COMMON_LOCALIZATION_MESSAGES')
		localStorage.removeItem('COMPANY_LOCALIZATION_MESSAGES')
	},
	[UPLOAD_USER_LOCALISATION]: (state, locale) => {
		state.locale = locale
		window.i18n = i18n
		state.loadedCommonLocale = true
	},
	[TRANSLATED_DIFFERENCE]: (state, translated) => {
		state.translationDifference = translated.data
	},
	[AUTH_LOGOUT]: () => {
		localStorage.setItem('COMMON_LOCALIZATION_MESSAGES', JSON.stringify(state.COMMON_LOCALIZATION_MESSAGES))
	}
}

function checkUpdateManager (url, lang, localization) {
	return new Promise(resolve => {
		checkConfigUpdate({
			[localization]: state[localization].etag
		}).then(resp => {
			if (resp) {
				if (resp.data.length === 0) {
					resolve(state[localization])
				} else {
					resolve(http.get(url, { params: { locale: lang } }))
				}
			}
		}).catch(errors => {
			console.error(errors)
			/*Vue.rollbar.error('CHECK_CONFIG_UPDATE', errors)*/
		})
	})
}

export function getI18n (lang, type) {
	if (type === 'common') {
		if (store.getters.isAuthenticated) {
			return checkUpdateManager('config/common-localization-messages', lang, 'COMMON_LOCALIZATION_MESSAGES')
		} else {
			return axios.get(process.env.VUE_APP_NODE_API_URL + '/config/common-localization-messages', { params: { locale: lang } })
		}
	}
	if (type === 'company') {
		if (store.getters.isAuthenticated) {
			return checkUpdateManager('config/company-localization-messages', lang, 'COMPANY_LOCALIZATION_MESSAGES')
		} else {
			return axios.get(process.env.VUE_APP_NODE_API_URL + '/config/company-localization-messages', { params: { locale: lang } })
		}
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
